/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailboxReplyDTO
 */
export interface MailboxReplyDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxReplyDTO
     */
    Body: string;
}

/**
 * Check if a given object implements the MailboxReplyDTO interface.
 */
export function instanceOfMailboxReplyDTO(value: object): value is MailboxReplyDTO {
    if (!('Body' in value) || value['Body'] === undefined) return false;
    return true;
}

export function MailboxReplyDTOFromJSON(json: any): MailboxReplyDTO {
    return MailboxReplyDTOFromJSONTyped(json, false);
}

export function MailboxReplyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxReplyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Body': json['Body'],
    };
}

export function MailboxReplyDTOToJSON(json: any): MailboxReplyDTO {
    return MailboxReplyDTOToJSONTyped(json, false);
}

export function MailboxReplyDTOToJSONTyped(value?: MailboxReplyDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Body': value['Body'],
    };
}

